import { render, staticRenderFns } from "./AamsDocumentBaseCategory.vue?vue&type=template&id=a21528e8&scoped=true&"
import script from "./AamsDocumentBaseCategory.vue?vue&type=script&lang=js&"
export * from "./AamsDocumentBaseCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a21528e8",
  null
  
)

export default component.exports